import { submitPaymentDetails } from 'src/helpers/api/verifications';
import { loadPaymentDetails } from 'src/redux/modules/paymentDetails';
import { VerifyBankAccountFormData } from 'src/containers/forms/AddBankAccountModalContainer';
import { Dispatch } from 'redux';
import { AppState } from 'src/redux/modules';
import { convertDateToUTC } from 'src/helpers/date';

const BANK_REQUEST = 'BANK_REQUEST';
const BANK_SUCCESS = 'BANK_SUCCESS';
const BANK_FAILURE = 'BANK_FAILURE';

export type AddBankAccountData = VerifyBankAccountFormData & {
  pageId: string;
  pageName: string;
};

export function addBankAccount(account: AddBankAccountData) {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    dispatch({
      type: BANK_REQUEST,
      payload: account,
    });

    const payload = {
      projectId: account.pageId,
      sortcode: account.sortCode,
      accountNumber: account.accountNumber,
      title: account.title,
      firstName: account.firstName,
      lastName: account.lastName,
      phoneNumber: account.phoneNumber,
      addressLine1: account.addressLine1,
      addressLine2: account.addressLine2,
      town: account.town,
      postCode: account.postCode,
      dateOfBirth: convertDateToUTC(new Date(account.dob)),
    };

    let result;

    try {
      result = await submitPaymentDetails(payload);
    } catch (error) {
      dispatch({
        type: BANK_FAILURE,
        error: true,
        payload: { message: 'serverError', error },
      });

      throw new Error('serverError');
    }

    if (result.approved) {
      const status = getState().page.status;

      dispatch({ type: BANK_SUCCESS, payload: { approved: true } });
      dispatch({
        type: 'UPDATE_SUCCESS',
        payload: {
          verificationStatus: 'Verified',
          status: status === 'Suspended' ? 'Active' : status,
        },
      });
      dispatch(loadPaymentDetails());
    } else {
      dispatch({
        type: BANK_FAILURE,
        error: true,
        payload: { message: result.reason },
      });

      throw new Error(result.reason);
    }
  };
}

export default function reducer(
  state = {},
  action: { type: string; payload: { message: string } }
) {
  switch (action.type) {
    case BANK_REQUEST:
      return {
        ...state,
        isRequesting: true,
        errorMessage: null,
      };
    case BANK_SUCCESS:
      return {
        ...state,
        isRequesting: false,
        lastRequested: Date.now(),
        errorMessage: null,
      };
    case BANK_FAILURE:
      return {
        ...state,
        isRequesting: false,
        errorMessage: action.payload.message,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/bank.ts